module.exports = __webpack_public_path__ + "img/英文版_库尔_海南.6e4b5a1e.webp";